import React, { createContext, FC, PropsWithChildren, useCallback, useReducer } from 'react'
import { meContextReducer } from './reducer'
import { initialMeContextState } from './state'
import { IMeContext } from './types'
import { useBootstrapMeContext } from './hooks'

export const MeContext = createContext<IMeContext>({
  state: initialMeContextState,
  dispatch: () => null,
  can: () => false,
})

export const MeProvider: FC<PropsWithChildren> = ({ children }) => {
  const [state, dispatch] = useReducer(meContextReducer, initialMeContextState)

  const can = useCallback(
    (id: number) => {
      return !!state.user.data?.permissions.includes(id)
    },
    [state.user.data?.permissions],
  )

  useBootstrapMeContext(state, dispatch)

  return <MeContext.Provider value={{ state, dispatch, can }}>{children}</MeContext.Provider>
}
